import React from "react";
import Table from "react-bootstrap/Table";
import { FaDotCircle } from "react-icons/fa";

const ContactTable = () => {
    return (
        <Table bordered hover>
            <thead>
                <tr>
                    <th
                        colSpan="2"
                        className="text-primary fs-5"
                        style={{
                            textAlign: "center",
                            padding: "10px",
                        }}
                    >
                        For Any Query, Contact Our Virtual B2B Team:
                    </th>
                </tr>
            </thead>
            <tbody>
                {/* Project Head Row */}
                <tr>
                    <td colSpan="2" style={{ textAlign: "center", padding: "15px" }}>
                        <div
                            className="fw-bold text-primary"
                            style={{ fontSize: "18px" }}
                        >
                            <span> Virtual B2B Forum Sales & Marketing </span><br />
                            <span>Mrs. Swarn Dhiman ( Executive Director )</span>
                        </div>
                        <div
                            className="fw-semibold"
                            style={{ fontWeight: 300, color: "grey", marginTop: "10px" }}
                        >
                            <div className="d-flex gap-4 text-center justify-content-center align-items-center">
                                <div>
                                    WhatsApp:{" "}
                                    <a
                                        href="https://wa.me/918433720996"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#007bff", textDecoration: "none" }}
                                    >
                                        +91-8433720996
                                    </a>
                                </div>
                                <div>
                                    Board Lines:{" "}
                                    <a
                                        href="tel:+912241271145"
                                        style={{ color: "#007bff", textDecoration: "none" }}
                                    >
                                        +91-22-41271145
                                    </a>{" "}
                                    |{" "}
                                    <a
                                        href="tel:+912241271146"
                                        style={{ color: "#007bff", textDecoration: "none" }}
                                    >
                                        46
                                    </a>{" "}
                                    |{" "}
                                    <a
                                        href="tel:+912241271147"
                                        style={{ color: "#007bff", textDecoration: "none" }}
                                    >
                                        47
                                    </a>
                                </div>
                            </div>
                            <div>
                                Email:{" "}
                                <a
                                    href="mailto:ed@aecci.org.in"
                                    style={{ color: "#007bff", textDecoration: "none" }}
                                >
                                    ed@aecci.org.in
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
                {/* Legal and Technical Columns */}
                <tr>
                    <td style={{ textAlign: "center", padding: "15px" }}>
                    <div
                            className="fw-bold text-primary"
                            style={{ fontSize: "18px" }}
                        >
                            Collaborator / Participant Support
                        </div>
                        <div
                            className="fw-semibold"
                            style={{ fontWeight: 300, color: "grey", marginTop: "10px" }}
                        >
                            <div>
                                <span>Advocate Rohini P K</span>{"  "}<span className="fw-bold">-</span>  {"  "}
                                <span>Advocate Akshata Mulik</span>
                            </div>
                            <div>
                                Email:{" "}
                                <a
                                    href="mailto:legal@aecci.org.in"
                                    style={{ color: "#007bff", textDecoration: "none" }}
                                >
                                    legal@aecci.org.in
                                </a>
                            </div>
                        </div>
                    </td>
                    <td style={{ textAlign: "center", padding: "15px" }}>
                    <div
                            className="fw-bold text-primary"
                            style={{ fontSize: "18px" }}
                        >
                            Web Application Support
                        </div>
                        <div
                            className="fw-semibold"
                            style={{ fontWeight: 300, color: "grey", marginTop: "10px" }}
                        >
                            <div>Mr. Swapnil Mahadik</div>
                            <div>
                                Email:{" "}
                                <a
                                    href="mailto:webmaster@aecci.org.in"
                                    style={{ color: "#007bff", textDecoration: "none" }}
                                >
                                    webmaster@aecci.org.in
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </Table>
    );
};

export default ContactTable;
